import React, { Component } from "react";
import { Toast } from "react-bootstrap";

export class ToastComponent extends Component {
  state: {
    visible: boolean;
    message: string;
    status: "danger" | "success" | "info";
    position: "right" | "center" | "left";
  };

  constructor(props: any) {
    super(props);
    this.state = {
      visible: false,
      message: "",
      status: "info",
      position: "left",
    };
  }

  onShow = (message: string, status: "danger" | "success" | "info", position: "right" | "center" | "left") => {
    this.setState({ message, visible: true, status, position });
  };

  onClose = () => {
    this.setState({ message: "", visible: false });
  };

  render() {
    return (
      <Toast
        delay={5000}
        autohide
        onClose={this.onClose}
        show={this.state.visible}
        animation={true}
        style={{
          position: "fixed",
          top: this.state.position === "left" ? "10%" : this.state.position === "center" ? "25%" : "10%",
          right: this.state.position === "left" ? "70%" : this.state.position === "center" ? "25%" : 20,
          zIndex: 1000,
          backgroundColor:
            this.state.status === "danger" ? "#ee8989" : this.state.status === "info" ? "#8fd4e9" : "#6acb5f",
          borderColor:
            this.state.status === "danger" ? "#e86060" : this.state.status === "info" ? "#68c5e1" : "#36b927",
          color: this.state.status === "danger" ? "#652424" : this.state.status === "info" ? "#285462" : "#104f09",
        }}
      >
        <Toast.Header
          style={{
            backgroundColor:
              this.state.status === "danger" ? "#ee8989" : this.state.status === "info" ? "#8fd4e9" : "#6acb5f",
            borderColor:
              this.state.status === "danger" ? "#e86060" : this.state.status === "info" ? "#68c5e1" : "#36b927",
            color: this.state.status === "danger" ? "#652424" : this.state.status === "info" ? "#285462" : "#104f09",
          }}
        >
          <strong className="mr-auto">L192 Seller</strong>
        </Toast.Header>
        <Toast.Body>{this.state.message}</Toast.Body>
      </Toast>
    );
  }
}
